<div *ngIf="loader; else elseBlock" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  
  
  
  <ng-template #elseBlock>
    <div class="divHome">
      <h1>Notas de Crédito de Proveedores</h1>
  
  
      <div style="display: flex; justify-content: center">
        <mat-form-field appearance="outline" class="divInputSearch">
          <!-- <mat-label>Filtrar</mat-label> -->
          <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar">
        </mat-form-field>
      </div>
  
  
      <div class="divButtons">
  
        <mat-form-field appearance="fill"  class="buttonFilter">
          <mat-label>FILES</mat-label>
          <mat-select [(value)]="selectFile" (selectionChange)="applyFilterSelect()">
            <mat-option value={{null}}>No seleccionar</mat-option>
            <mat-option *ngFor="let file of arrayFiles" value={{file}}>{{file}}</mat-option>
          </mat-select>
        </mat-form-field>
  
  
        <mat-form-field appearance="fill" class="buttonFilter">
          <mat-label>PROVEEDOR</mat-label>
          <mat-select [(value)]="selectProveedor" (selectionChange)="applyFilterSelect()">
            <mat-option value={{null}}>No seleccionar</mat-option>
            <mat-option *ngFor="let proveedor of arrayProveedores" value={{proveedor}}>{{proveedor}}</mat-option>
          </mat-select>
        </mat-form-field>
  
  
        <mat-form-field appearance="fill"  class="buttonFilter">
          <mat-label>NUM OS</mat-label>
          <mat-select [(value)]="selectOS" (selectionChange)="applyFilterSelect()">
            <mat-option value={{null}}>No seleccionar</mat-option>
            <mat-option *ngFor="let os of arrayOS" value={{os}}>{{os}}</mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearance="fill" class="buttonFilter">
          <mat-label>ESTADO </mat-label>
          <mat-select [(value)]="selectEstado" (selectionChange)="applyFilterSelect()">
            <mat-option value={{null}}>No seleccionar</mat-option>
            <mat-option *ngFor="let optionSelect of arrayEstado"
                        value={{optionSelect}}>{{optionSelect}}</mat-option>
          </mat-select>
        </mat-form-field>
   
  
  
        <mat-form-field class="buttonFilterFecha" >
          <mat-label> FECHA DE CREACIÓN</mat-label>
          <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-input [rangePicker]="rangePicker" >
            <input matStartDate placeholder="Inicio" [(ngModel)]="startDate">
            <input matEndDate placeholder="Fin"   [(ngModel)]="endDate">
          </mat-date-range-input>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button  mat-button matDateRangePickerCancel>Cancel</button>
              <button style="background-color: rgb(184, 69, 18);" mat-raised-button color="primary" (click)="onApplyRangeSelected()" matDateRangePickerApply>Filtrar</button>
              <button  mat-button matDateRangePickerCancel (click)="cleanDateSelected(1)">  Limpiar</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
 
  
      </div>
  
  
      <div class="example-container mat-elevation-z8" *ngIf="dataSource" style="margin-top: 2rem;">
  
        <mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="codigo">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> CÓDIGO </mat-header-cell>
                <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.codigo}}  </mat-cell>
              </ng-container>

          <ng-container matColumnDef="fileNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> FILE </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.fileNumber}}  </mat-cell>
          </ng-container>
  
          <ng-container matColumnDef="numberOS">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> NÚMERO OS </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.numberOS}} </mat-cell>
          </ng-container>
  
  
          <ng-container matColumnDef="nameProveedor">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> PROVEEDOR </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.nameProveedor}} </mat-cell>
          </ng-container>
  
          <ng-container matColumnDef="reef">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> REEF </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.reef}}  </mat-cell>
          </ng-container>
          <ng-container matColumnDef="saf">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> SAF </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.saf}}  </mat-cell>
          </ng-container>
          <ng-container matColumnDef="penalidad">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> Penalidad </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.penalidad}}  </mat-cell>
          </ng-container>

          <ng-container matColumnDef="partialPayment">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> Pago Parcial </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.partialPayment}}  </mat-cell>
          </ng-container>

          <ng-container matColumnDef="moneda">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> Moneda </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.moneda}}  </mat-cell>
          </ng-container>
  
          <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> FECHA CREACIÓN </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.createdAt | date:'dd/MM/yyyy'}} </mat-cell>
          </ng-container>
  
  
          <ng-container matColumnDef="estado">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> ESTADO </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.estado}} </mat-cell>
          </ng-container>

  
  
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;">
          </mat-row>
        </mat-table>
  
      </div>
  
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons></mat-paginator>
    </div>
  
  
  
  </ng-template>
  